/**
 * @generated SignedSource<<4cf851e5f0dc52f630c1116bb5536d28>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateEducationLevelCriteriaInput = {
  clientMutationId?: string | null | undefined;
  educationLevelIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type useEducationLevelCriteriaMutation$variables = {
  input: UpdateEducationLevelCriteriaInput;
};
export type useEducationLevelCriteriaMutation$data = {
  readonly updateEducationLevelCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useEducationLevelCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useEducationLevelCriteriaMutation = {
  response: useEducationLevelCriteriaMutation$data;
  variables: useEducationLevelCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEducationLevelCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateEducationLevelCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateEducationLevelCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useEducationLevelCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useEducationLevelCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateEducationLevelCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateEducationLevelCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "EducationLevelCriterionConnection",
                    "kind": "LinkedField",
                    "name": "educationLevelCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EducationLevelCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "educationLevelId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "educationLevelCriteria(orderBy:[\"EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e04b4ffbc1ea6160e826df8e76e92b0",
    "id": null,
    "metadata": {},
    "name": "useEducationLevelCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useEducationLevelCriteriaMutation(\n  $input: UpdateEducationLevelCriteriaInput!\n) {\n  updateEducationLevelCriteria(input: $input) {\n    query {\n      ...useEducationLevelCriteria_query\n      id\n    }\n  }\n}\n\nfragment useEducationLevelCriteria_query on Query {\n  currentUser {\n    educationLevelCriteria(orderBy: [EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC]) {\n      nodes {\n        educationLevelId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "533460c322ebe7f93699011eb3674b7e";

export default node;
